import { Locale } from 'modules/i18n';

export const codeSnippetPlaceholderTranslation = {
  [Locale.en]: {
    noContent: 'No content',
  },
};
